import React from "react";
import styled from "styled-components";
import { SCREEN_WIDTH_BREAKPOINT } from "constant/common_constants";
import GroupList from "components/common/dl_group/GroupList/GroupList";

const groupsData = [
  {
    name: "OKTOBARSKI SALON",
    text: "je izložba reprezentativnih dela iz sfere aktuelnog stvaralaštva u oblasti vizuelnih umetnosti, koja ima status stalne manifestacije u oblasti kulture od značaja za Grad Beograd.Savet Moderne galerije (koja je s vremenom prerasla u Muzej savremene umetnosti u Beogradu) na osnovu svog statuta i akta Sekretarijata za prosvetu i kulturu Narodnog odbora grada Beograda na sednici održanoj 19. maja 1960. godine doneo je rešenje o osnivanju Oktobarskog salona.",
    image: "images/oktobarski_salon.jpg",
    link: "/g/oktobarski-salon",
  },
  {
    name: "PETAR LUBARDA",
    text: "je rođen 1907. u Ljubotinju nedaleko od Cetinja, od oca Đura I. Lubarde, oficira crnogorske vojske, a potom potpukovnika Vojske Kraljevine Jugoslavije, i majke Marije M. Vujović, domaćice. Imao je petoro braće i sestara.",
    image: "images/umetnik_1_srednja3.jpg",
    link: "/g/petar-lubarda",
  },
  {
    name: "SAVA ŠUMANOVIĆ",
    text: "je rođen 24. januara 1896. u Vinkovcima u imućnoj građanskoj porodici, Perside i Milutina Šumanovića. Posle ranog očevog penzionisanja 1900. porodica se vraća u Šid, gde Sava pohađa osnovnu školu.",
    image: "images/umetnik_2_srednja3.jpg",
    link: "/g/sava-sumanovic",
  },
  {
    name: "MUZEJ SAVREMENE UMETNOSTI",
    text: "1948. godine je Raspisan prvi (uži) konkurs za zgradu Moderne galerije na levoj obali reke Save. Prvu nagradu na konkursu su dobili arhitekti Edvard Ravnikar i Veljko Kauzlarić. Druga nagrada pripala je arhitekti Branku Petričiću. Projekat nije realizovan.",
    image: "images/g/muzej_01_2.jpg",
    link: "/g/muzej-savremene-umetnosti",
  },
  {
    name: "AVANGARDA",
    text: "U februaru 1921.godine počinje da izlazi časopis Zenit – Internacionalna revija za umetnost i kulturu. Urednik Ljubomir Micić. U prvom broju časopisa Zenit izlazi Zenitistički manifest Ivana Golla pisan na nemačkom i Manifest zenitizma čiji su potpisnici Ljubomir Micić, Ivan Goll i Boško Tokin. Zenit uspostavlja aktivnu saradnju sa Arhipenkom osnivačem umetničke škole u Berlinu. ",
    image: "images/g/04_avangarda_srednja2.jpg",
    link: "/g/avangarda",
  },
  {
    name: "NADEŽDA PETROVIĆ",
    text: "je rođena 11. oktоbra 1873. u Čačku. Otac Dimitrije Mita Petrović bio je nastavnik crtanja u Realnoj gimnaziji u Čačku, a majka Mileva učiteljica. Nadežda je bila najstarije od devetoro dece.",
    image: "images/nadezda-petrovic-s3.jpg",
    link: "/g/nadezda-petrovic",
  },
  {
    name: "KONCEPTUALNA UMETNOST",
    text: "Hronologija konceptualne umetnosti u Jugoslaviji",
    image: "/images/g/Naslovna foto konceptualna_2.jpg",
    link: "/g/konceptualna-umetnost",
  },
];

const CitajteoStart: React.FC = () => {
  return <GroupList groupsData={groupsData} />;
};

export default CitajteoStart;
